import { render, staticRenderFns } from "./StudyResult.vue?vue&type=template&id=02b3f168&lang=pug"
import script from "./StudyResult.vue?vue&type=script&lang=ts"
export * from "./StudyResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports